import { Ics2Referral, Ics2ReferralDraft } from 'store/declarations/eu/ics2/customs-requests/types';

export const DOCUMENT_REQUEST_CODES = ['F700', 'D10'];
export const DOCUMENT_REFUSAL_CODES = ['R202', 'D00'];

const hasCode = (codes: string[], entries?: Array<{ code?: string }>) =>
    (entries ?? []).some((entry) => entry.code && codes.includes(entry.code));

export const getRequestedDocuments = (referral: Ics2Referral) => referral.requestDetails?.supportingDocuments ?? [];

/** Whether Customs asked for every document available, rather than for named ones. */
export const requestsAllDocuments = (referral: Ics2Referral) =>
    hasCode(DOCUMENT_REQUEST_CODES, referral.requestDetails?.additionalInformation);

export const describeDocumentRequest = (
    referral: Ics2Referral,
    formatType: (type: string) => string = (type) => type
): string | undefined => {
    const named = getRequestedDocuments(referral)
        .map((document) =>
            [document.type && formatType(document.type), document.referenceNumber && `(${document.referenceNumber})`]
                .filter(Boolean)
                .join(' ')
        )
        .filter(Boolean);

    if (named.length) return named.join(', ');
    return requestsAllDocuments(referral) ? 'all available documents' : undefined;
};

export const needsEvidenceConfirmation = ({
    draft,
    attachmentCount,
}: {
    draft?: Ics2ReferralDraft;
    attachmentCount: number;
}): boolean => attachmentCount === 0 && !hasCode(DOCUMENT_REFUSAL_CODES, draft?.additionalInformation);
